import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import styled from 'styled-components';
import { trackEvent } from '../analytics';
import { HeavyText, LightItalicText } from './Style';
import { VinylDisc, VINYL_THEMES } from './UserBadge';

var Overlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1200;
`;

var Modal = styled.div`
  background: white;
  border-radius: 16px;
  width: 90%;
  max-width: 320px;
  padding: 1.5rem;
  position: relative;
  text-align: center;
`;

var CloseButton = styled.button`
  position: absolute;
  top: 0.75rem;
  right: 0.75rem;
  background: none;
  border: none;
  cursor: pointer;
  padding: 0.25rem;
  color: #999;
  font-size: 1.25rem;
  line-height: 1;
`;

var Logo = styled.div`
  font-size: x-large;
  margin-bottom: 0.5em;
`;

var Title = styled.div`
  font-weight: 800;
  font-size: 1rem;
  margin-bottom: 0.5em;
`;

var Subtitle = styled.div`
  color: #777;
  font-size: 0.85rem;
  line-height: 1.4;
  margin-bottom: 1.25em;
`;

var SignupButton = styled(Link)`
  display: block;
  background: black;
  color: white;
  text-decoration: none;
  font-weight: 700;
  font-size: 0.85rem;
  padding: 0.65em 1.5em;
  border-radius: 8px;
  margin-bottom: 0.75em;

  &:hover {
    background: #333;
  }
`;

var ExploreButton = styled(Link)`
  display: block;
  background: white;
  color: black;
  text-decoration: none;
  font-weight: 700;
  font-size: 0.85rem;
  padding: 0.55em 1.5em;
  border: 1px solid black;
  border-right-width: 2px;
  border-bottom-width: 2px;
  border-radius: 8px;
  margin-bottom: 0.75em;

  &:hover {
    background: #f5f5f5;
  }
`;

var LoginLink = styled(Link)`
  color: #999;
  font-size: 0.75rem;
  text-decoration: none;

  &:hover {
    color: #666;
  }
`;

var ShareButton = styled.button`
  display: block;
  width: 100%;
  background: none;
  color: #999;
  border: none;
  font-weight: 600;
  font-size: 0.8rem;
  font-family: inherit;
  padding: 0.5em 0;
  cursor: pointer;
  margin-bottom: 0.5em;

  &:hover {
    color: #666;
  }
`;

function SignupPromptModal(props) {
  var _copied = useState(false);
  var copied = _copied[0];
  var setCopied = _copied[1];

  function handleShareClick() {
    var url = window.location.href;
    navigator.clipboard
      .writeText(url)
      .then(function () {
        setCopied(true);
        trackEvent('signup_prompt_share', { source: props.source || 'unknown', url: url });
        setTimeout(function () {
          setCopied(false);
        }, 2000);
      })
      .catch(function () {});
  }

  function handleOverlayClick() {
    props.onClose();
  }

  function handleModalClick(e) {
    e.stopPropagation();
  }

  function handleSignupClick() {
    trackEvent('signup_prompt_clicked', { source: props.source || 'unknown' });
  }

  function handleExploreClick() {
    trackEvent('signup_prompt_explore', { source: props.source || 'unknown' });
    props.onClose();
  }

  return (
    <Overlay onClick={handleOverlayClick}>
      <Modal onClick={handleModalClick}>
        <CloseButton onClick={props.onClose} aria-label="Close">
          &times;
        </CloseButton>
        <div style={{ marginBottom: '0.5em' }}>
          <VinylDisc theme={VINYL_THEMES.test_pressing} size={56} spinning />
        </div>
        <Logo>
          <HeavyText>Heavy</HeavyText>
          <LightItalicText>Rotation</LightItalicText>
        </Logo>
        <Subtitle>
          HeavyRotation is a social network for sharing and discovering music you love. It's like an
          endless mixtape curated by your friends.
        </Subtitle>
        <Title>{props.title || 'Sign up to join the community.'}</Title>
        <SignupButton to="/signup" state={{ referer: props.referer }} onClick={handleSignupClick}>
          Create an Account
        </SignupButton>
        <ExploreButton to="/" onClick={handleExploreClick}>
          Curious? See What Others Are Posting
        </ExploreButton>
        <ShareButton onClick={handleShareClick}>
          {copied ? 'Link Copied!' : 'Share This Music'}
        </ShareButton>
        <LoginLink to="/login">Log in</LoginLink>
      </Modal>
    </Overlay>
  );
}

export default SignupPromptModal;
